// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text__create_agent{
    color: #061522;
font-size: 28px;
font-style: normal;
font-weight: 500;
line-height: 34px; /* 121.429% */
}
.text__start_agent{
    color: #556575;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 128.571% */
}`, "",{"version":3,"sources":["webpack://./src/pages/AgentPassword/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC;AACA;IACI,cAAc;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC","sourcesContent":[".text__create_agent{\n    color: #061522;\nfont-size: 28px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 34px; /* 121.429% */\n}\n.text__start_agent{\n    color: #556575;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 18px; /* 128.571% */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
